import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { TakeawayServices } from '../../../services';
/**
 * Component para la generacion de la lista agrupada de tickets en el tpv ademas de su opcion
 * de count, no count y delete
 */

@Component({
  selector: 'page-takeaway-order-select-selected-list',
  templateUrl: 'takeaway-order-select-selected-list.html',
})
export class TakeawayOrderSelectSelectedListPage {
  @Input() selected_list: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public takeawayServices: TakeawayServices) {

  }

  deleteTableList(valueSearch, index) {
    //delete element
    var position_element = Object.keys(this.selected_list[index].list).find(k => this.selected_list[index].list[k].name === valueSearch);
    delete this.selected_list[index].list[Number(position_element)];

    //if section empty delete section
    if (Object.keys(this.selected_list[index].list).length == 0) {
      this.selected_list.splice(index, 1);
    }

    //data set waiter activity
    var extra_activity: any =
    {
      'type': 'remove',
      'value': 1,
      'source': 'takeaway',

    };
    this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');


  }


}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order-select/takeaway-order-select-selected/takeaway-order-select-selected-list/takeaway-order-select-selected-list.ts